import React from 'react';
import { FormField as FormFieldType, FormData, FormErrors } from '../../../../../types/ContactForm';

interface EmailWithCopyFieldProps {
    field: FormFieldType;
    formData: FormData;
    errors: FormErrors;
    inputCssClass?: string;
    onInputChange: (name: string, value: any) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const EmailWithCopyField: React.FC<EmailWithCopyFieldProps> = ({
    field,
    formData,
    errors,
    inputCssClass,
    onInputChange,
    onFieldFocus
}) => {
    const handleInputChange = (value: any) => {
        onInputChange(field.name, value);
        onFieldFocus(field.name);
    };

    const getInputClassName = (baseClass: string) => {
        return `${baseClass} ${inputCssClass || ''}`.trim();
    };

    return (
        <div className={`col-12 col-md-${field.width || 12}`}>
            <div
                className={`form-group ${field.required ? 'required' : ''} ${errors[field.name] ? 'has-error' : ''}`}>
                <label htmlFor={`field-${field.id}`} className="control-label">
                    {field.label}
                </label>
                <input
                    type="email"
                    id={`field-${field.id}`}
                    name={field.name}
                    className={getInputClassName('form-control')}
                    placeholder={field.placeholder || ""}
                    value={formData[field.name] || ''}
                    onChange={(e) => handleInputChange(e.target.value)}
                    required={field.required}
                    maxLength={255}
                    aria-required={field.required}
                />
                {errors[field.name] && (
                    <div className="form-error-msg text-danger">
                        <i className="fa fa-warning"></i> {errors[field.name]}
                    </div>
                )}
            </div>
        </div>
    );
};

